export default __webpack_public_path__ + "assets/uv-index-6.310db877.svg";